<template>
    <div style="width: 1000px;min-height:100vh;display: flex;justify-content: center;align-items: center;margin: 0 auto;">
        <div style="margin-top: 120px;">
            <div style="width: 1000px;min-height:1000px;background: #FFFFFF">
                <div style="clear: both;display: flex;align-items: center;padding-top: 40px;">
                    <div style="font-size: 25px;color:#444444;font-weight:bold;display: flex;justify-content: center;flex: 1;">外包项目备案</div>
                </div>
                <div style="clear: both;padding-top: 30px;">
                    <div style="width: 920px;height: 10px;background: #2970FF;border-radius: 20px 20px 0px 0px;margin: 0 auto;"></div>
                    <div class="gradient-border" style="width: 916px;min-height: 450px;clear: both;margin: 0 auto;box-shadow: 0px 2px 6px 1px rgba(0,0,0,0.16);">
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">项目负责人</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704364278528}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">日期</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704365009815}}</td>
                            </tr>
                        </teble>
                        <table border="1" style="width: 100%;height: 50px;overflow: hidden;font-size: 14px;border: none;">
                            <tr class="typeface">
                                <th class="title">项目名称</th>
                                <td class="content">{{content.fd_1677729356192}}</td>
                            </tr>
                            <tr class="typeface">
                                <th class="title">外包项目名称</th>
                                <td class="content">{{content.fd_1704365052914}}</td>
                            </tr>
                            <tr class="typeface">
                                <th class="title">所属专业</th>
                                <td class="content">{{content.fd_1704365371466}}</td>
                            </tr>
                            <tr class="typeface">
                                <th class="title">外包内容</th>
                                <td class="content">{{content.fd_1704365495666}}</td>
                            </tr>
                            <tr class="typeface">
                                <th class="title">外包成果</th>
                                <td class="content">{{content.fd_1704365519358}}</td>
                            </tr>
                            <tr class="typeface">
                                <th class="title">外包单位</th>
                                <td class="content">{{content.fd_1704365545875}}</td>
                            </tr>
                        </table>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 43px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">联系人</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704365602840}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">联系电话</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704365605714}}</td>
                            </tr>
                        </teble>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">总金额</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704365607864}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">已付金额</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704365610162}}</td>
                            </tr>
                        </teble>
                        <table border="1" style="width: 100%;height: 50px;overflow: hidden;font-size: 14px;border: none;">
                            <tr class="typeface">
                                <th class="title" style="border-bottom: none">付款方式</th>
                                <td class="content" style="border-bottom: none">{{content.fd_1704365681514}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {

    },

    computed: {

    },
    data () {
        return {
            content:{},
        }
    },
    mounted:function(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.getRoomContent()
    },
    methods:{
        // 获取内容
        getRoomContent() {
            this.newApi.getRoomContentInfo({id: this.$route.params.id}).then(res =>{
                this.content = res.data.content;
            })
        },

    }
}
</script>
<style scoped>
.title {
    width: 100px;
    height: 20px;
    padding: 23px 26px;
    font-size: 17px;
    color: #444444;
    border-bottom:1px solid #CFCFCF;
    font-weight: bold;
    border-right:1px solid #CFCFCF;
    border-left: none;
    border-top: none;
    font-family:'SimHei';

}
.content {
    font-size: 17px;
    height: 20px;
    color: #444444;
    width: 80%;
    border-bottom:1px solid #CFCFCF;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 10px;
}
.typeface {
    font-family:'SimHei';
    width: 100%
}
.gradient-border {
    border-right: 2px solid #ddd;
    border-left: 2px solid #ddd;
    border-image: linear-gradient(rgb(41, 112, 255), #FFFFFF) 30 30;
}
</style>